module.exports = __webpack_public_path__ + "img/topic-moved.74ab105f.png";